import { Map } from 'immutable';

import * as t from '../../actions/friendProfileActionType';

const initialState = Map({
  friendHeader: {
    requestPending: false,
    friend: true,
    firstName: 'Name',
    lastName: 'lastName',
    pfeRate: 'Aviation Boatswain’s Mate, Launching and Recovery Equipment',
    cycle: 'HM2 Regular March 2019',
    points: '444',
    level: 5,
    badges: 17,
    chaper: 'BUMEDINST QUALITY ASSURANCE (QA) PROGRAM0133',
    avatarUrl: '',
  },
});

const reducer = function FriendHeaderReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_FRIEND_HEADER:
      return state.set('friendHeader', action.friendHeaderData);
    default:
      return state;
  }
};

export default reducer;
